export enum MarkerSettingType {
  Label = 'Label',
  LabelAbove = 'LabelAbove',
  Marker = 'Marker',
}

export const isLabelType = (type: MarkerSettingType): type is MarkerSettingType.Label | MarkerSettingType.LabelAbove =>
  type === MarkerSettingType.Label || type === MarkerSettingType.LabelAbove;
